import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// Bootstrap 5.3.3 and Bootstrap Icons 1.11.3 - the same versions the Razor layout pulled from
// the CDN, installed as packages so the built bundle is fully self-contained on S3.
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

// The portal's own theme, copied unchanged from web/wwwroot/css.
import './styles/site.css';

// Marketing page styles - hero, pricing cards, trust bar. Copied from web/wwwroot/css alongside
// site.css when the portal was ported, but unused until LandingPage existed to need them.
import './styles/landing.css';

// Self-service signup pages - stepper, plan cards, review rows.
import './styles/signup.css';

// Developer documentation (/docs) - sidebar, code blocks, callouts. Mirrors web/wwwroot/css/docs.css.
import './styles/docs.css';

// Public /demo - the demo switch and verification demo. Mirrors web/wwwroot/css/demo.css.
import './styles/demo.css';

import { App } from './App';
import { AuthProvider } from './auth/AuthContext';
import { ToastProvider } from './components/ToastProvider';

// Pages are loaded on demand (App.tsx), and a deploy deletes the previous build's files
// (deploy-lambda.ps1 syncs with --delete). A tab opened before a deploy would then fail to load a
// page it has not opened yet. Vite raises vite:preloadError for that; reload once to pick up the
// new build. The session flag stops a reload loop if the file is missing for some other reason.
window.addEventListener('vite:preloadError', (event) => {
  try {
    if (sessionStorage.getItem('idverify-reloaded-for-chunk')) return;
    sessionStorage.setItem('idverify-reloaded-for-chunk', '1');
  } catch {
    /* storage unavailable: reload anyway, once per event */
  }
  event.preventDefault();
  window.location.reload();
});
window.addEventListener('load', () => {
  // A page that loaded cleanly clears the flag, so the next deploy can reload again.
  window.setTimeout(() => {
    try {
      sessionStorage.removeItem('idverify-reloaded-for-chunk');
    } catch {
      /* ignore */
    }
  }, 10000);
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
